// AnnouncementPopup.tsx

import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import useGetAnnouncement from '../../hooks/useGetAnnouncement';
import { isImgUrl } from '../viewRecipe/utils/imgUrl';
import styles from './AnnouncementPopup.module.css';

interface ManualDataProps {
    background_color?: string | null,
    title?: string | null,
    subtitle?: string | null,
    image?: string | null
}
interface CustomModalProps {
    open: boolean;
    onClose: () => void;
    onCtaClick: () => void;
    mediaUrl?: string | null;
    manual?: ManualDataProps | null;
    buttonText?: string | null;
}

const MediaDisplay = ({ url }: { url: string }) => {
    
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isMuted, setIsMuted] = useState(true);
    
    if (!url) {
        return null;
    }

    const isImage = isImgUrl(url);

    const handleMuteToggle = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setIsMuted(videoRef.current.muted);
        }
    };

    if (isImage) {
        return <img alt="Modal Content" className={styles.modal_media} src={url} />;
    }
    return (
        <div className={styles.videoContainer}>
        <video autoPlay className={styles.modal_media} loop
            muted ref={videoRef}>
            <source src={url} type="video/mp4" />
        </video>
        <ButtonBase className={styles.muteButton} onClick={handleMuteToggle}>
                {isMuted ? <VolumeOffOutlinedIcon /> : <VolumeUpOutlinedIcon />}
        </ButtonBase>
        </div>
    );

};

const AnnouncementModal = ({
    open,
    onClose,
    onCtaClick,
    mediaUrl,
    manual,
    buttonText,
}: CustomModalProps) => {

    const mediaContentUrl = manual?.image || mediaUrl;

    return <Modal className={styles.modal} onClose={onClose} open={open}>
        <Grid className={styles.paper}
            style={{ backgroundColor: manual?.background_color ?? "#ffffff" }}>
            <IconButton className={styles.closeIcon} onClick={onClose}>
                <CloseIcon color="error" fontSize="large" />
            </IconButton>
            <Grid className={styles.modal_content_container}>
                <Grid className={styles.modal_content}>
                    {mediaContentUrl ? <MediaDisplay url={mediaContentUrl} /> : null}
                    <Grid className={styles.modal_content_text}>
                        {manual?.title ? <Typography className={styles.modal_header} variant="h6">{manual.title}</Typography> : null}
                        {manual?.subtitle ? <Typography className={styles.modal_text} variant="body5">{manual.subtitle}</Typography> : null}
                    </Grid>
                </Grid>
                {buttonText ?
                    <ButtonBase className={styles.modal_cta_btn} onClick={onCtaClick}>
                        <Typography variant="body5">{buttonText}</Typography>
                    </ButtonBase> : null
                }
            </Grid>
        </Grid>
    </Modal>
}
    ;

AnnouncementModal.defaultProps = {
    mediaUrl: null,
    buttonText: null,
    manual: null
};

const AnnouncementPopup = () => {

    const { showPopup, onClose, popupData } = useGetAnnouncement();
    const { image, type, manual, button_text: btnText, action } = popupData;
    const history = useHistory();
    const handleCtaClick = () => {
        if (action) {
            if (action.startsWith('/')) {
                history.push(action)
            } else {
                window.open(action, '_blank');
            }
        }
        onClose("CTA_CLICKED")
    };

    return (
        <div>
            <AnnouncementModal
                buttonText={btnText}
                manual={manual}
                mediaUrl={image}
                onClose={onClose}
                onCtaClick={handleCtaClick}
                open={showPopup}
            />
        </div>
    );
};

export default AnnouncementPopup;

